import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash/fp';
import moment from 'moment';

import Slots from './Slots/index';
import NoSlotsFiller from './NoSlotsFiller/index';
import DoctorProfile from './DoctorProfile/index';
import NextAvailableSlot from '../../../../BookingPageMobile/NextAvailableSlot/index';
import { doctorProfilePropType } from '../../../../propTypes/index';
import { filterTypes } from '../../../../BookingPageMobile/actions/filterActions';
import styles from './doctorMainComponent.module.css';

const hasAvailableSlots = appointments =>
  appointments.morning.length > 0 ||
  appointments.afternoon.length > 0 ||
  appointments.evening.length > 0;

const hasMorningSlots = appointments => 
  appointments.morning.length > 0;

const hasAfternoonSlots = appointments => 
  appointments.afternoon.length > 0;

  const hasEveningSlots = appointments => 
  appointments.evening.length > 0;


const hasAnyAvailableSlot = allAppointment =>
  allAppointment.some(appt => hasAvailableSlots(appt) === true);

const getPartitionedAppointments = (appointments, currentFilter) => {
  switch (currentFilter) {
    case filterTypes.morning:
      return appointments.morning;
    case filterTypes.afternoon:
      return appointments.afternoon;
    case filterTypes.evening:
      return appointments.evening;
    default:
      return appointments.morning;
  }
};
const getCurrentDay = appointments => {
  if (appointments.morning.length) return appointments.morning[0].Time;
  if (appointments.afternoon.length) return appointments.afternoon[0].Time;
  if (appointments.evening.length) return appointments.evening[0].Time;
  return moment().format('dddd');
};

class DoctorMainComponent extends Component {
  static propTypes = {
    doctor: doctorProfilePropType.isRequired,
    toggleDoctorProfile: PropTypes.func.isRequired,
    setTime: PropTypes.func.isRequired,
    currentFilter: PropTypes.string.isRequired,
    appointments: doctorProfilePropType.isRequired,
    isFetching: PropTypes.bool,
    filterToDate: PropTypes.func.isRequired,
  };
  state = {
    showAll: false,
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.appointments !== this.props.appointments &&
      this.state.showAll
    ) {
      this.setState({ showAll: false });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.appointments !== this.props.appointments) return true;
    else if (nextProps.isFetching !== this.props.isFetching) return true;
    else if (nextProps.currentFilter !== this.props.currentFilter) return true;
    else if (nextState.showAll !== this.state.showAll) return true;
    return false;
  }
  getMaxSlots = () =>
    this.props.appointments.AvailableSlots.reduce((max, slots) => {
      const length = getPartitionedAppointments(slots, this.props.currentFilter)
        .length;
      return Math.max(length, max);
    }, 0);
  toggleShowAll = () => {
    this.setState({ showAll: !this.state.showAll });
  };
  render() {
    const {
      doctor,
      appointments,
      currentFilter,
      setTime,
      toggleDoctorProfile,
      isFetching,
      filterToDate,
      filterMorning,
      filterAfternoon,
      filterEvening
    } = this.props;
    return (
      <div className={styles.container} key={doctor.PmsUserId}>
        <DoctorProfile
          toggleDoctorProfile={toggleDoctorProfile}
          doctor={doctor}
        />
        <div className={styles.appointmentContainer}>
          {(() => {
            const result = hasAnyAvailableSlot(appointments.AvailableSlots);
            if (isFetching) {
              return <NoSlotsFiller />;
            } else if (result) {
              return map(
                s => (
                  <Slots
                    key={s.day}
                    isFetching={isFetching}
                    appointments={getPartitionedAppointments(s, currentFilter)}
                    hasAvailableSlots={hasAvailableSlots(s)}
                    currentDay={getCurrentDay(s)}
                    currentFilter={currentFilter.toLowerCase()}
                    toggleShowAll={this.toggleShowAll}
                    showAll={this.state.showAll}
                    setTime={setTime}
                    doctorId={doctor.PmsUserId}
                    maxLength={this.getMaxSlots()}
                    hasMorningSlots={hasMorningSlots(s)}
                    hasAfternoonSlots={hasAfternoonSlots(s)}
                    hasEveningSlots={hasEveningSlots(s)}
                    filterMorning={filterMorning}
                    filterAfternoon={filterAfternoon}
                    filterEvening={filterEvening}
                    sessionId={doctor.SessionId}
                  />
                ),
                appointments.AvailableSlots,
              );
            } else if (!appointments.NextAvailableSlot) {
              return (
                <div className={styles.notAvailableContainer}>
                  <div className={styles.notAvailable}>
                    No available slots in the next 30 days.
                  </div>
                </div>
              );
            }
            return (
              <NextAvailableSlot
                nextAvailableDate={appointments.NextAvailableSlot}
                onClickAction={() =>
                  filterToDate(appointments.NextAvailableSlot)
                }
                isDesktop
              />
            );
          })()}
        </div>
      </div>
    );
  }
}

export default DoctorMainComponent;
